/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, since: "false" | "true" }} Valve_UnavailableInputs */



/**
* | since | output |
* | --- | --- |
* | "false" | "Th. head not available" |
* | "true" | "Th. head not available since {date}" |
*
* @param {Valve_UnavailableInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const valve_unavailable = /** @type {((inputs: Valve_UnavailableInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Valve_UnavailableInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.since === "false") return /** @type {LocalizedString} */ (`Th. head not available`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`Th. head not available since ${i?.date}`);
		return /** @type {LocalizedString} */ ("valve_unavailable");
	}
	{
		if (i?.since === "false") return /** @type {LocalizedString} */ (`Tête non disponible`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`Tête non disponible depuis le ${i?.date}`);
		return /** @type {LocalizedString} */ ("valve_unavailable");
	}
});